import { EnvironmentType } from "@models/env";

export const environment = {
  env: EnvironmentType.homolog,
  cognito: {
    domain: "https://us-west-2JE54l0zgv.auth.us-west-2.amazoncognito.com",
    apiRest: "https://cognito-idp.us-west-2.amazonaws.com",
    userPoolId: "us-west-2_JE54l0zgv",
    userClientId: "4i4aupal5f72iffgc7gnpbmvdh",
    responseType: "code",
    scope: "profile email openid",
    region: "us-west-2",
  },
  grpc: {
    scope: ["profile", "email", "openid"],
  },
  PAYWALL_URL: "https://admin.svm.homolog.supermup.com.br/paywall",
  SVM_HOME: "https://h-diariodonordeste.verdesmares.com.br/",
};
